import { useInView } from '@blaze-react/utils/lib/customHooks';

const useInfographic = ({ className: _className, ...props }) => {
  const [isIntersecting, contentRef] = useInView({
    once: true,
    offset: '200px'
  });

  const className = `${_className} infographic${isIntersecting ? ' infographic__active' : ''}`;

  return {
    ...props,
    className,
    contentRef
  };
};

export default useInfographic;
